module.exports = __webpack_public_path__ + "5b95201cc785cddb92d45803f907cf91.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/chefs-palace-main.png
// module id = 2811
// module chunks = 0